import { createSlice } from '@reduxjs/toolkit';

import setAllowRotateReducer from './reducer/setAllowRotateReducer';
import setGapMmReducer from './reducer/setGapMmReducer';
import setMarginMmReducer from './reducer/setMarginMmReducer';
import { GangSheetState } from './types';

export const gangSheetInitialState: GangSheetState = {
  gapMm: undefined,
  marginMm: undefined,
  allowRotate: undefined,
};

export const slice = createSlice({
  name: 'gangSheet',
  initialState: gangSheetInitialState,
  reducers: {
    setGapMmAction: setGapMmReducer,
    setMarginMmAction: setMarginMmReducer,
    setAllowRotateAction: setAllowRotateReducer,
  },
});

export const { setGapMmAction, setMarginMmAction, setAllowRotateAction } = slice.actions;

const gangSheetReducer = slice.reducer;

export default gangSheetReducer;
